import { render, staticRenderFns } from "./OrdersManagement.vue?vue&type=template&id=564ee9e6&scoped=true"
import script from "./OrdersManagement.vue?vue&type=script&lang=js"
export * from "./OrdersManagement.vue?vue&type=script&lang=js"
import style0 from "./OrdersManagement.vue?vue&type=style&index=0&id=564ee9e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ee9e6",
  null
  
)

export default component.exports